module.exports = __webpack_public_path__ + "img/checkbox_24.2fb75d7b.svg";